module.exports = __webpack_public_path__ + "static/media/255.311ca8d2.jpg";